// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.box[data-v-54e35cd6] {\r\n  display: flex;\r\n  gap: 12px;\n}\n.box > *[data-v-54e35cd6] {\r\n  flex: 1 1 0;\n}\n.custom-control-input.is-invalid ~ .custom-control-label[data-v-54e35cd6] {\r\n  color: inherit;\n}\r\n", ""]);
// Exports
module.exports = exports;
